"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APPLICATION_TYPES = void 0;
const APPLICATION_TYPES = ['server_to_server', 'public', 'elements', 'management'];
exports.APPLICATION_TYPES = APPLICATION_TYPES;